import { Component, Input, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PayeeCasesService } from '../payee-cases.service';
import { Stage } from '../types';
import { ChipDropdownComponent } from '../chip-dropdown/chip-dropdown.component';
import { PayeeDropdownComponent } from '../../payee-form-fields/payee-dropdown/payee-dropdown.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'payee-case-stage-filter',
  templateUrl: './case-stage-filter.component.html',
  styleUrls: ['./case-stage-filter.component.scss'],
  imports: [
    ChipDropdownComponent,
    PayeeDropdownComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeButtonComponent,
    TranslateModule,
  ],
})
export class CaseStageFilterComponent {
  private translate = inject(TranslateService);
  private payeeCasesService = inject(PayeeCasesService);

  readonly stageControl = new FormControl<Stage | null>(null);

  dropdownOpen = false;

  @Input({ required: true }) stages!: Stage[];

  get stage() {
    return this.payeeCasesService.stage.value;
  }

  readonly displayWith = (stage?: string): string => {
    if (!stage) {
      return '';
    }

    return this.translate.instant(
      `CASES_TABLE.FILTERS.STAGE.${stage.toUpperCase()}`,
    );
  };

  applyFilter(): void {
    this.payeeCasesService.stage.next(this.stageControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.payeeCasesService.stage.next(null);
    this.dropdownOpen = false;
  }
}
